/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { iccidState, releaseESIMRemote } from '../../../helpers/iccidStatus';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';

type IccidPoolsReleaseType = {
    iccid: PlatformIccidPoolNumber;
    open: boolean;
    reload(): void;
    close(): void;
};

export const IccidPoolsReleaseESim: FunctionComponent<IccidPoolsReleaseType> = ({ open, close, iccid, reload }): ReactElement => {
    const dispatch = useDispatch();
    const [currentStatus, setCurrentStatus] = useState<number>(iccid.iccidState);

    useEffect(() => {
        if (open) {
            setCurrentStatus(iccid.iccidState);
        }
    }, [open, iccid]);

    const setNewStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setCurrentStatus(parseInt(String(event.target.value)));
    };

    const changeStatus = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(iccid['@id']),
            'update-status-time-msisdn',
            { iccidState: releaseESIMRemote },
            (data: PlatformIccidPoolNumber): void => {
                reload();
                close();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <Dialog fullWidth={true} maxWidth="sm" open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="pools:sim.cancel_release_e_sim" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <I18n trans="pools:sim.confirm_cancel_release_e_sim" />
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={close} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={changeStatus} callbackParam={{}} label="general:common.ok" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
